import * as React from "react";

export const useEffectAfterMount = (callback, dependencies?: any[]) => {
    const hasMounted = React.useRef(false);

    React.useEffect(() => {
        if (hasMounted.current) {
            callback();
        }
        hasMounted.current = true;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};
